import React, { useEffect, useState } from "react"
import mount from "core/mount"
import useScript from "hooks/use-script"
import wistiaVideo from "app/shared/assets/wistia-video.svg?inline"
import "./wistia-video.css"

const WistiaVideo = ({ wistiaVideoId, className }) => {
  const status = useScript("https://fast.wistia.com/assets/external/E-v1.js")
  const [handle, setHandle] = useState(null)

  useEffect(() => {
    if (status !== "ready") return
    window._wq = window._wq || []
    window._wq.push({
      id: wistiaVideoId,
      onReady: function(video) {
        setHandle(video)
      }
    })
  }, [status])

  const playVideo = () => {
    const wistiaApi = handle && handle.container.wistiaApi
    if (wistiaApi) {
      wistiaApi.popover.show()
      wistiaApi.play()
    }
    analytics.track("App Interaction - Video", {
      destination: null,
      url: window.location.href,
      video_id: wistiaVideoId,
      category: "onboarding",
      interaction_type: "played"
    })
  }

  return (
    <section
      className={`flex place-content-center wistia-video relative ${className}`}
    >
      <div
        className="relative w-full"
        style={{ padding: "62.5% 0 0 0", height: "14.5rem", maxWidth: "18rem" }}
      />
      <div
        className="w-full absolute left-0 top-0 overflow-hidden rounded"
        style={{ height: "14.5rem", maxWidth: "20rem" }}
      >
        <div
          className={`wistia_embed wistia_async_${wistiaVideoId} popover=true popoverAnimateThumbnail=true videoFoam=true playButton=false`}
          style={{ height: "14.5rem" }}
        >
          &nbsp;
        </div>
      </div>
      <button
        className="bg-blue-800 bg-opacity-25 absolute top-0 left-0 rounded-lg flex items-center justify-center cursor-pointer focus:outline-none group"
        style={{ width: "20rem", height: "14.5rem" }}
        onClick={playVideo}
      >
        <span className="bg-white h-16 w-16 rounded-full flex items-center justify-center transform group-hover:scale-110 transition duration-150">
          <img src={wistiaVideo} alt="Play video" className="h-6 ml-1 center" />
        </span>
      </button>
    </section>
  )
}

export default WistiaVideo
mount({ "Wistia.Video": WistiaVideo })
